<template>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512.001 512.001" style="enable-background:new 0 0 512.001 512.001;" xml:space="preserve">
<g>
	<g>
		<circle cx="247.887" cy="264.102" r="13.632"/>
	</g>
</g>
<g>
	<g>
		<circle cx="284.257" cy="227.722" r="13.632"/>
	</g>
</g>
<g>
	<g>
		<circle cx="320.627" cy="191.363" r="13.632"/>
	</g>
</g>
<g>
	<g>
		<circle cx="211.518" cy="300.472" r="13.632"/>
	</g>
</g>
<g>
	<g>
		<circle cx="175.138" cy="336.842" r="13.632"/>
	</g>
</g>
<g>
	<g>
		<circle cx="95.586" cy="416.393" r="13.632"/>
	</g>
</g>
<g>
	<g>
		<path d="M448.691,78.392l-15.103-15.103c-2.96-2.96-7.759-2.96-10.72,0l-11.862,11.862c-7.131,7.131-7.131,18.692,0,25.823
			s18.692,7.131,25.823,0l11.862-11.862C451.651,86.152,451.651,81.353,448.691,78.392z"/>
	</g>
</g>
<g>
	<g>
		<path d="M508.579,24.463c-5.493-9.155-11.868-15.545-21.06-21.06c-8.551-5.13-19.697-4.396-27.484,1.839
			c-10.028,8.031-32.368,24.203-69.327,42.271c-17.469,8.539-31.54,24.072-41.935,46.199c-3.232-1.348-6.73-2.057-10.336-2.057
			c-7.168,0-13.908,2.792-18.977,7.86c-8.622,8.623-10.132,21.698-4.544,31.889l-28.029,28.029c-2.93,2.93-2.93,7.679,0,10.609
			c2.93,2.93,7.68,2.93,10.609,0l27.268-27.268l44.441,44.44L228.602,327.82c-2.93,2.93-2.93,7.68,0,10.609
			c2.893,2.893,7.719,2.892,10.61,0l141.354-141.355c3.914,2.157,8.328,3.308,12.92,3.308c7.168,0,13.908-2.792,18.976-7.86
			c7.598-7.598,9.944-19.39,5.805-29.313c22.127-10.396,37.66-24.468,46.2-41.935c18.068-36.957,34.239-59.299,42.271-69.328
			C513.006,44.12,513.745,33.075,508.579,24.463z M401.854,181.913c-4.564,4.564-12.173,4.559-16.735,0
			c0,0-55.05-55.05-55.053-55.053c-4.611-4.613-4.61-12.119,0.003-16.732c4.557-4.557,12.183-4.55,16.734,0
			c0,0,55.043,55.043,55.052,55.052C406.482,169.677,406.368,177.398,401.854,181.913z M495.027,42.568
			c-10.285,12.841-26.273,35.778-44.039,72.116c-7.363,15.061-21.509,27.264-42.087,36.323l-47.926-47.927
			c9.058-20.579,21.262-34.723,36.323-42.086c36.342-17.767,59.276-33.755,72.116-44.039c2.948-2.361,7.154-2.625,10.386-0.686
			c7.095,4.257,11.64,8.791,15.913,15.913C497.668,35.441,497.392,39.615,495.027,42.568z"/>
	</g>
</g>
<g>
	<g>
		<path d="M276.459,180.472c-2.93-2.93-7.68-2.93-10.609,0L115.2,331.123c-3.914-2.157-8.327-3.308-12.92-3.308
			c-7.169,0-13.908,2.792-18.977,7.86c-8.853,8.853-10.214,22.404-4.084,32.704c-5.156,6.235-17.131,18.321-37.363,25.994
			c-4.425-3.035-9.653-4.672-15.135-4.672c-7.168,0-13.908,2.792-18.976,7.86c-10.333,10.334-10.317,27.637,0,37.953
			c0,0,68.675,68.676,68.721,68.723c10.348,10.348,27.613,10.34,37.953,0c9.26-9.262,10.319-23.658,3.187-34.101
			c7.628-20.073,19.77-32.145,26.015-37.352c4.105,2.448,8.806,3.755,13.71,3.755c7.168,0,13.908-2.792,18.976-7.86
			c8.622-8.622,10.133-21.697,4.544-31.888l37.93-37.93c2.93-2.93,2.93-7.68,0-10.609c-2.929-2.932-7.679-2.932-10.609-0.001
			l-37.171,37.17L126.56,340.98l149.899-149.899C279.389,188.151,279.389,183.402,276.459,180.472z M103.809,493.628
			c-4.569,4.569-12.175,4.559-16.734,0c0,0-68.609-68.611-68.721-68.723c-4.561-4.561-4.554-12.18,0-16.734
			c4.568-4.568,12.171-4.562,16.734,0l68.721,68.721C108.423,481.508,108.423,489.014,103.809,493.628z M106.32,458.186
			l-52.524-52.524c17.768-8.059,29.299-18.897,35.525-26.014l43.015,43.015C125.218,428.887,114.379,440.417,106.32,458.186z
			 M165.698,401.335c4.612,4.614,4.611,12.12-0.001,16.733c-4.567,4.567-12.178,4.556-16.734,0c0,0-55.05-55.05-55.053-55.053
			c-4.611-4.613-4.611-12.118,0.002-16.732c4.568-4.569,12.168-4.566,16.736,0C110.647,346.284,165.697,401.334,165.698,401.335z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>
